import React from 'react';
import { ProTable } from 'react-pro-components';
import { Tabs } from 'ssc-ui-react';

import { $gt } from '@/common/appCtx';

import { usePermissions } from '../permissions';
import { useBatchTableProps } from './hooks/use-batch-table-props';
import { useInitBreadcrumb } from './hooks/use-init-breadcrumb';
import { useSingleTableProps } from './hooks/use-single-table-props';
import style from './index.module.less';

export default function LogListPage() {
  const hasPermission = usePermissions();
  const batchLogTableProps = useBatchTableProps();
  const singleLogTableProps = useSingleTableProps();
  useInitBreadcrumb();

  return (
    <div className={style.root}>
      <h3 className={style.title}>{ $gt('Workstation Log') }</h3>
      <Tabs
        defaultActiveKey="batch_log"
        style={{ padding: '0 24px', background: '#fff' }}
        animated
      >
        <Tabs.TabPane tab={$gt('Single Log')} key="single_log">
          <ProTable {...singleLogTableProps} />
        </Tabs.TabPane>
        {hasPermission('workstationBatchLog') ? (
          <Tabs.TabPane tab={$gt('Batch Log')} key="batch_log">
            <ProTable {...batchLogTableProps} />
          </Tabs.TabPane>
        ): null}
      </Tabs>
    </div>
  );
}
